import { __rest } from "tslib";
import { Checkbox, Form, Radio, Select } from 'antd';
import React, { useState } from 'react';
import styles from './extraselect.module.scss';
import { getIn18Text } from 'api';
const ExtraSelect = (_a) => {
    var { capacity_list, instruments, onChange, getPopoverContainer } = _a, rest = __rest(_a, ["capacity_list", "instruments", "onChange", "getPopoverContainer"]);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const handleFinish = (values) => {
        const { capacity_code, instruments } = values;
        onChange &&
            onChange({
                capacity_code,
                instruments,
            });
        setOpen(false);
    };
    return (React.createElement(Select, Object.assign({ onDropdownVisibleChange: setOpen, open: open, placeholder: getIn18Text('GENGDUOSHAIXUAN'), defaultValue: getIn18Text('GENGDUOSHAIXUAN'), dropdownMatchSelectWidth: false, dropdownClassName: styles.dropDown, getPopupContainer: getPopoverContainer, dropdownRender: () => (React.createElement(Form, { form: form, layout: "vertical", colon: false, onFinish: handleFinish, initialValues: {
                capacity_code: capacity_list[0].code,
                instruments: [instruments[0].code],
            } },
            React.createElement(Form.Item, { name: "capacity_code", label: getIn18Text('RONGNARENSHU') },
                React.createElement(Radio.Group, { className: styles.checkgroup, options: capacity_list.map(ca => ({
                        label: ca.name,
                        value: ca.code,
                    })) })),
            React.createElement(Form.Item, { name: "instruments", label: getIn18Text('SHEBEI'), normalize: (value, prevValue) => {
                    if (Array.isArray(value) && Array.isArray(prevValue)) {
                        const unlimitedCode = '0';
                        const valueSet = new Set(value);
                        const prevValueSet = new Set(prevValue);
                        if (valueSet.size > 1 && prevValueSet.has(unlimitedCode)) {
                            valueSet.delete(unlimitedCode);
                        }
                        if (!prevValueSet.has(unlimitedCode) && valueSet.has(unlimitedCode)) {
                            valueSet.clear();
                            valueSet.add(unlimitedCode);
                        }
                        if (valueSet.size === 0) {
                            return prevValue;
                        }
                        return Array.from(valueSet);
                    }
                    return value;
                } },
                React.createElement(Checkbox.Group, { className: styles.checkgroup, options: instruments.map(ca => ({
                        label: ca.name,
                        value: ca.code,
                    })) })),
            React.createElement("div", { className: styles.footer },
                React.createElement("button", { type: "reset", className: styles.default }, getIn18Text('ZHONGZHI')),
                React.createElement("button", { type: "submit", className: styles.primary }, getIn18Text('QUEDING'))))) }, rest)));
};
export default ExtraSelect;
